const PhoneAHW = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.965 16.61L17.792 15.437C17.206 14.851 16.256 14.851 15.671 15.437L14.749 16.359C14.543 16.565 14.231 16.634 13.965 16.517C12.629 15.932 11.309 15.045 10.132 13.868C8.96002 12.696 8.07602 11.382 7.49002 10.051C7.36802 9.776 7.43902 9.453 7.65202 9.24L8.47802 8.414C9.14902 7.743 9.14902 6.794 8.56302 6.208L7.39002 5.035C6.60902 4.254 5.34302 4.254 4.56202 5.035L3.91002 5.686C3.16902 6.427 2.86002 7.496 3.06002 8.556C3.55402 11.169 5.07202 14.03 7.52102 16.479C9.97002 18.928 12.831 20.446 15.444 20.94C16.504 21.14 17.573 20.831 18.314 20.09L18.965 19.439C19.746 18.658 19.746 17.392 18.965 16.61V16.61Z"
      stroke="#A3A3A3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 6.991C14.031 6.977 15.067 7.359 15.854 8.146"
      stroke="#A3A3A3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.682 5.31799C17.113 3.74899 15.056 2.96399 13 2.96399"
      stroke="#A3A3A3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.009 11C17.023 9.969 16.641 8.933 15.854 8.146"
      stroke="#A3A3A3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.682 5.31799C20.251 6.88699 21.036 8.94399 21.036 11"
      stroke="#A3A3A3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { PhoneAHW };
